<template>
    <mvtWelcome>
            <template v-slot:img>
                <img :src="glb.cdnUrl + 'vimages/owner-welcome.jpg'" alt="Welcome Home Owner" fetchpriority="auto" />
            </template>
            <template v-slot:content>
                <div class="f7">MOVOTO HOMEOWNER</div>
                <h1 class="f0 text-bold">{{molang('homeOwner.FinancialGuide')}}</h1>
                <div class="f5"> {{molang('homeOwner.GetSmarterSubText')}} </div>
                <mvtInputGeo class="large default" ref="addressInput" v-model="geoInfo" :placeholder="molang('homeOwner.Address')" :options="{types:['address']}">{{molang('homeOwner.GetStarted')}}</mvtInputGeo>
            </template>
    </mvtWelcome>
</template>

<script src="./owner-welcome.js"></script>
